import React from 'react';
import styled from 'styled-components';

export default styled.div`
  .react-autosuggest__container {
    display: block;
    flex-basis: 49%;
    margin-right: 5px;
    position: relative;
  }
  .react-autosuggest__input {
    font-family: $font-general;
    font-size: 16px;
    color: $color-primary;
    background-color: $color-light;
    border: 1px solid $borderColor;
    padding: 10px;
    outline: none;
    width: 100%;
    border-radius: $border-radius;

    &::-webkit-input-placeholder {
      color: $color-primary;
    }
    &::-moz-placeholder {
      color: $color-primary;
    }
    &:-ms-input-placeholder {
      color: $color-primary;
    }
    &:-moz-placeholder {
      color: $color-primary;
    }
  }

  .react-autosuggest__suggestions-container--open {
    position: absolute;
    top: 100%;
    background-color: white;
    border: 1px solid rgb(85, 85, 85);
    width: 100%;
    z-index: 1001;
  }
  .react-autosuggest__suggestions-list {
    list-style-type: none;
  }
`;
